<template>
	<div class="Subscribe_Manage _popRight" id="SubscribeManage_pop" style="display: block;"><!-- trial_apply -->
		<div class="pop_right"><!-- pop_right -->
			<ul class="pop_right_header2">
				<li><h2>专题订阅管理</h2></li>
				<li><btn class="pop_right_close2" name="pop-close" @click="closeFloat"></btn></li>
			</ul>
			<div class="pop_right_main"><!-- main -->
		
					<h3>专题</h3>
					<ul class="group3b">
						<li v-for="(item,index) in zhuantiList" class="group3b_item">
							<div @click="showSelectPanel(item.columnid,$event)" @blur="hideSelectPanel" tabindex="99" class=" cei-select select_sty1" name="cei-select" style="width:100%">
								<i class="cei-icon" :class="{'icon-arrup icon-arrow-on':selectedactive==item.columnid,'icon-arrdown':selectedactive!=item.columnid}"></i>
								<div class="inpout" >
									<dot :style="{'background':((selectedactive==item.columnid||dingyueList[index].length)?'#bd1a2d!important':'#a1a4ab')}"></dot>
									<name :class="{'red':dingyueList[index].length}" >{{item.columnname}}</name>
									<numbers v-show="dingyueList[index].length">+{{dingyueList[index].length}}</numbers>
								</div>
								<figure v-show="selectedactive==item.columnid" class="MyTabs Mulchoice_list_out"><!-- MyTabs -->
								  	<el-checkbox-group v-model="dingyueList[index]">
								  		<el-checkbox v-for="(subitem,subindex) in item.Child" :label="subitem.columnid">{{subitem.columnname}}</el-checkbox>
								  	</el-checkbox-group>
								</figure><!-- /MyTabs -->	
							</div>
						</li>
					</ul>
					
			</div><!-- /main -->
			<div class="pop_right_footer2">
					<btn class="s_btn" @click="saveUserOrders"  >确定</btn>
			</div>
		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /trial_apply -->
</template>

<script>
	export default{
		data() {
			return {
				loadingMask:false,
				guanlishow: false,
				// articlesList:[],
				dingyueList:[],
				origindingyueList:[],
				origindingyuecount:0,
				colidstring:'',
				zhuantiList:[],
				selectedactive:'',
			}
		},
		mounted:function(){
			this.getAllUserOrder();
			this.$track([
				['pagetype','我的订阅']
			]);
		},
		methods:{
			// getDingyueArticles:function(){
			// 	let _this = this;
			// 	_this.loadingMask = true;
			// 	this.$http({
			// 			method: 'get',
			// 			url: 'recommend/getSubscribeArticles',
			// 			responseType: 'json',
			// 			params: {
			// 				userid:this.$cookies.get('userinfo')?this.$cookies.get('userinfo').userAccountID:'',
			// 				iPage:'1',
			// 				pageSize:'10',
			// 			},
			// 		})
			// 		.then(function(response) {
			// 			_this.articlesList=response.data.data.data.data
			// 			_this.loadingMask = false;
			// 		})
			// 		.catch(function(error) {
			// 			_this.loadingMask = false;
			// 			console.log(error);
			// 		});
			// },
			hideSelectPanel:function(evnet){
				this.selectedactive='';
				// console.log('blur'+this.selectedactive);
			},
			showSelectPanel:function(id,event){
				// console.log(event.target.tagName+' '+event.target.className);
				// if(event.target.tagName!='DIV'&&event.target.tagName!='NAME'&&event.target.tagName!='NUMBERS'&&event.target.tagName!='I'){
				// 	// event.preventDefault();
				// 	return false;
				// }
				// if(event.target.className.indexOf('el-checkbox')>-1){
				// 	return false;
				// }
				if(this.selectedactive==id){
					if(event.target.tagName=='FIGURE'||event.target.className=='el-checkbox-group'){
						return false;
					}
					// if(event.target.tagName=='NAME'||event.target.tagName=='NUMBERS'||event.target.tagName=='I'){
					// 	this.selectedactive='';
					// }
					this.selectedactive='';
				}
				else{
					this.selectedactive=id;
				}
				// console.log(this.selectedactive);
			},
			getAllUserOrder:function(){
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/selectAllUserOrder',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						var tempdata=response.data.data.data;
						for(var i=0;i<tempdata.length;i++){
							var tempchild=[];
							for(var j=0;j<tempdata[i].Child.length;j++){
								if(tempdata[i].Child[j].Child&&tempdata[i].Child[j].Child.length>0){
									for(var k=0;k<tempdata[i].Child[j].Child.length;k++){
										tempdata[i].Child[j].Child[k].columnname=tempdata[i].Child[j].columnname+'-'+tempdata[i].Child[j].Child[k].columnname;
									}
									tempchild=tempchild.concat(tempdata[i].Child[j].Child);
								}
							}
							if(tempchild.length>0){
								tempdata[i].Child=tempchild;
							}
						}
						var dingyuedata=tempdata;
						_this.origindingyueList=[];
						_this.origindingyuecount=0;
						for(var i=0;i<dingyuedata.length;i++){
							_this.origindingyueList.push([]);
							for(var j=0;j<dingyuedata[i].Child.length;j++){
								if(dingyuedata[i].Child[j].ordertype=="1"){
									_this.origindingyueList[i].push(dingyuedata[i].Child[j].columnid);
									_this.origindingyuecount++;
								}
							}
						}
						_this.dingyueList = JSON.parse(JSON.stringify(_this.origindingyueList));
						_this.zhuantiList = dingyuedata;
						_this.loadingMask = false;
						// _this.getDingyueArticles();
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			saveUserOrders:function(){
				this.colidstring='';
				for(var i=0;i<this.dingyueList.length;i++){
					if(this.dingyueList[i].length>0){
						if(this.colidstring){
							this.colidstring+=',';
						}
						this.colidstring+=this.dingyueList[i].join(',');
					}
				}
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/SaveUserOrders',
						responseType: 'json',
						params: {
							ColID:this.colidstring
						},
					})
					.then(function(response) {
						if(response.data.data.data.code=='0'){
							_this.$track([
								['pagetype','订阅修改'],
								['reqtype','3'],
								['column',_this.colidstring.replace(/,/g,' ')]
							]);
							_this.$message({
								message: '订阅修改成功',
								type: 'success'
							});
							_this.guanlishow=false;
							_this.getAllUserOrder();
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			closeFloat:function(){
				this.$emit('closefloat');
			}
		}
	}
</script>

<style>
	.Subscribe_Manage .MyTabs.Mulchoice_list_out{
		z-index: 3;
		line-height: 26px;
	}
	.Subscribe_Manage .el-checkbox{
/* 		float: left;
		clear: both; */
		width: 100%;
		margin-bottom: 8px;
	}
	.Subscribe_Manage .el-checkbox .el-checkbox__label{
		font-size: 16px;
	}
	.Subscribe_Manage .el-checkbox__input.is-checked .el-checkbox__inner{
		background-color: #bd1a2d;
		border: 1px solid #bd1a2d;
	}
	.Subscribe_Manage .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #606266;
	}
</style>
